<template>
  <div class="mx-auto quotes">
    <v-btn
      color="#6dbe45"
      class="btns"
      style="color: #ffffff"
      @click="navigateCartPage()"
      >Back To Cart</v-btn
    >
    <br />
    <br />
    <!-- if items are from multiple markets and the order type is pickup-->
    <div v-if="mulitple_markets_pickup" style="color: white">
      <h4>Get a Quote</h4>
      <strong style="padding: 50px">
        You have containers from different markets. Please contact us @ (800)
        768-6080.
      </strong>
      <br />
      <br />
      <div class="buttons">
        <v-btn
          color="white darken-1"
          text
          @click="navigateCartPage()"
          style="background-color: #6dbe45; font-weight: bold"
          >GO BACK</v-btn
        >
      </div>
      <br />
      <br />
    </div>
    <div v-else style="color: white; width: 80%; margin: auto">
      <!-- form for  capturing additional user info foR emailing quote -->
      <h4>GET A QUOTE</h4>
      <h5 style="padding: 5px">
        Please enter the details to get the quote emailed to you.
      </h5>
      <div class="user_input_form">
        <!-- Contact Details start-->
        <v-card-title>
          <span class="headline">Contact Information</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="4">
                <label for="first_name">First name</label>
                <br />
                <input
                  class="form"
                  type="text"
                  id="first_name"
                  v-model="first_name"
                />
                <br />
                <strong v-if="first_name_empty" style="color: orange"
                  >First name is required</strong
                >
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <label for="last_name">Last name</label>
                <br />
                <input
                  class="form"
                  type="text"
                  id="last_name"
                  v-model="last_name"
                />
                <br />
                <strong v-if="last_name_empty" style="color: orange"
                  >Last name is required</strong
                >
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <label for="phone_number">Phone</label>
                <br />
                <input
                  class="form"
                  type="text"
                  id="phone_number"
                  v-model="phone_number"
                  maxlength="14"
                />
                <br />
                <strong v-if="phone_number_empty" style="color: orange"
                  >Phone number is required</strong
                >
              </v-col>
              <v-col cols="12" sm="6" md="7">
                <label for="email">Email</label>
                <br />
                <input
                  class="form custom-width"
                  type="email"
                  id="email"
                  v-model="email"
                />
                <br />
                <strong v-if="email_empty" style="color: orange"
                  >Email is required</strong
                >
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <!-- Contact Details end-->
        <!-- Shipping Address start -->

        <v-card-title>
          <span class="headline">Shipping Address</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="7">
                <label for="shipping_company">Company (Optional)</label>
                <br />
                <input
                  class="form custom-width"
                  type="text"
                  id="shipping_company"
                  v-model="shipping_company"
                />
              </v-col>
              <v-col cols="12" sm="6" md="7">
                <label for="shipping_address">Address</label>
                <br />
                <input
                  class="form custom-width"
                  type="text"
                  id="shipping_address"
                  v-model="shipping_address"
                />
                <br />
                <strong v-if="shipping_address_empty" style="color: orange"
                  >Address is required</strong
                >
              </v-col>
              <v-col cols="12" sm="6" md="5">
                <label for="shipping_apartment">Unit # (optional)</label>
                <br />
                <input
                  class="form custom-width"
                  type="text"
                  id="shipping_apartment"
                  v-model="shipping_apartment"
                />
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <label for="shipping_city">City</label>
                <br />
                <input
                  class="form custom-width"
                  type="text"
                  id="shipping_city"
                  v-model="shipping_city"
                />
                <br />
                <strong v-if="shipping_city_empty" style="color: orange"
                  >City is required</strong
                >
              </v-col>
              <v-col cols="12" sm="6" md="2">
                <label for="shipping_country">Country</label>
                <br />
                <select
                  class="dropdown custom-select mr-sm-6"
                  id="shipping_country"
                  v-model="shipping_country"
                >
                  <option disabled value>--------</option>
                  <option value="United States">United States</option>
                  <option value="Canada">Canada</option>
                </select>
                <br />
                <strong v-if="shipping_country_empty" style="color: orange"
                  >Country is required</strong
                >
              </v-col>
              <v-col cols="12" sm="6" md="2">
                <label for="shipping_state">State</label>
                <br />
                <select
                  class="dropdown custom-select mr-sm-6"
                  id="shipping_state"
                  v-model="shipping_state"
                >
                  <option
                    disabled
                    value
                    v-if="shipping_country === 'United States'"
                  >
                    States
                  </option>
                  <option disabled value v-if="shipping_country === 'Canada'">
                    Provinces
                  </option>
                  <option
                    v-for="(state_code, state_name) in shipping_states"
                    v-bind:value="state_name"
                    :key="state_code"
                  >
                    {{ state_name }}
                  </option>
                </select>
                <br />
                <strong v-if="shipping_state_empty" style="color: orange"
                  >State is required</strong
                >
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <label for="shipping_zipcode"
                  >Zip code
                  <v-tooltip top color="#6dbe45">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon color="#6dbe45" v-bind="attrs" v-on="on"
                        >info</v-icon
                      >
                    </template>
                    <span style="color: black">{{
                      shippingZipCodeMessage
                    }}</span>
                  </v-tooltip>
                </label>
                <br />
                <input
                  class="form"
                  type="text"
                  id="shipping_zipcode"
                  v-model="VuexZipcode"
                  readonly
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <!-- Shipping Address end-->
        <!-- Billing Address start-->
        <v-card-title>
          <span class="headline">Billing Address</span>
        </v-card-title>
        <label
          for="billing_address"
          style="font-weight: 100; color: #ffffff; margin-left: 20px"
        >
          <input
            type="checkbox"
            id="billing_address"
            v-model="same_addresses"
          />
          &nbsp;Same as shipping address
        </label>
        <v-card-text v-if="!same_addresses">
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="7">
                <label for="billing_company">Company (Optional)</label>
                <br />
                <input
                  class="form custom-width"
                  type="text"
                  id="billing_company"
                  v-model="billing_company"
                />
              </v-col>
              <v-col cols="12" sm="6" md="7">
                <label for="billing_address">Address</label>
                <br />
                <input
                  class="form custom-width"
                  type="text"
                  id="billing_address"
                  v-model="billing_address"
                />
                <br />
                <strong v-if="billing_address_empty" style="color: orange"
                  >Address is required</strong
                >
              </v-col>
              <v-col cols="12" sm="6" md="5">
                <label for="billing_apartment">Unit # (optional)</label>
                <br />
                <input
                  class="form custom-width"
                  type="text"
                  id="billing_apartment"
                  v-model="billing_apartment"
                />
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <label for="billing_city">City</label>
                <br />
                <input
                  class="form custom-width"
                  type="text"
                  id="billing_city"
                  v-model="billing_city"
                />
                <br />
                <strong v-if="billing_city_empty" style="color: orange"
                  >City is required</strong
                >
              </v-col>
              <v-col cols="12" sm="6" md="2">
                <label for="billing_country">Country</label>
                <br />
                <select
                  class="dropdown custom-select mr-sm-6"
                  id="billing_country"
                  v-model="billing_country"
                >
                  <option disabled value>-----</option>
                  <option value="United States">United States</option>
                  <option value="Canada">Canada</option>
                </select>
                <br />
                <strong v-if="billing_country_empty" style="color: orange"
                  >State is required</strong
                >
              </v-col>
              <v-col cols="12" sm="6" md="2">
                <label for="billing_state">State</label>
                <br />
                <select
                  class="dropdown custom-select mr-sm-6"
                  id="billing_state"
                  v-model="billing_state"
                >
                  <option
                    disabled
                    value
                    v-if="billing_country === 'United States'"
                  >
                    States
                  </option>
                  <option disabled value v-if="billing_country === 'Canada'">
                    Provinces
                  </option>
                  <option
                    v-for="(state_code, state_name) in billing_states"
                    v-bind:value="state_name"
                    :key="state_code"
                  >
                    {{ state_name }}
                  </option>
                </select>
                <br />
                <strong v-if="billing_state_empty" style="color: orange"
                  >State is required</strong
                >
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <label for="billing_zipcode">Zip code</label>
                <br />
                <input
                  class="form"
                  type="text"
                  id="billing_zipcode"
                  v-model="billing_zipcode"
                />
                <br />
                <strong v-if="billing_zipcode_empty" style="color: orange"
                  >Zip code is required</strong
                >
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </div>
      <!-- Billing Address end-->
      <v-spacer></v-spacer>
      <small v-if="information_missing" style="color: orange"
        >*Please provide the required information before proceeding</small
      >
      <div class="buttons" v-if="!email_send_acknowledge">
        <v-btn
          color="#6dbe45"
          class="btns"
          style="color: #ffffff"
          @click="navigateCartPage()"
          >Cancel</v-btn
        >
        <v-btn
          color="#6dbe45"
          class="btns"
          style="color: #ffffff"
          @click="sendDraftOrder()"
          >Get Quote</v-btn
        >
      </div>
      <div style="padding: 10px" v-else>
        <label class="btn btn-outline-success">
          {{ confirmation_text_first }}
          <span>
            <a
              href="https://westerncontainersales.com/contact/"
              target="_blank"
              v-if="COUNTRY_CODE === 'US'"
              style="color: orange"
              >contact us</a
            >
            <a
              href="https://northerncontainersales.ca/contact/"
              target="_blank"
              v-if="COUNTRY_CODE === 'CA'"
              style="color: orange"
              >contact us</a
            >
            {{ confirmation_text_second }}
          </span>
        </label>
        <br />
        <br />
        <v-btn
          color="white darken-1"
          text
          @click="navigateCartPage()"
          style="background-color: #6dbe45; font-weight: bold"
          >Go Back</v-btn
        >
      </div>
      <br />
      <br />

      <!-- overlay form for quote ends -->
      <br />
      <br />
      <!-- Loader starts -->
      <v-overlay :value="userdata_sending">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
        <p>Sending....</p>
      </v-overlay>
      <v-overlay :value="userdata_sent">
        <i
          class="fa fa-check-circle sendAnimation"
          style="font-size: 60px; color: green"
        ></i>
        <p>Sent.</p>
      </v-overlay>
      <!-- Loader starts -->
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import * as states_list from "../JS/States";
import axios from "axios";
import * as types from "@/store/types";
import { enforceFormat, formatToPhone } from "@/JS/FormatPhoneNumber.js";
import * as shopify_store from "@/JS/ShopifyStore";

export default {
  name: "Quotes",
  data() {
    return {
      same_addresses: false,
      first_name: "",
      first_name_empty: false,
      last_name: "",
      last_name_empty: false,
      phone_number: "",
      phone_number_empty: false,
      email: "",
      email_empty: false,
      shipping_company: "",
      shipping_address: "",
      shipping_address_empty: false,
      shipping_apartment: "",
      shipping_city: "",
      shipping_city_empty: false,
      shipping_state: "",
      shipping_state_empty: false,
      shipping_country: "",
      shipping_country_empty: false,
      billing_company: "",
      billing_address: "",
      billing_address_empty: false,
      billing_apartment: "",
      billing_city: "",
      billing_city_empty: false,
      billing_state: "",
      billing_state_empty: false,
      billing_country: "",
      billing_country_empty: false,
      billing_zipcode: "",
      billing_zipcode_empty: false,
      mulitple_markets_pickup: false,
      depot_city: "",
      depot_state: "",
      depot_zipcode: "",
      depot_country: "",
      information_missing: false,
      userdata_sending: false,
      userdata_sent: false,
      email_send_acknowledge: false,
      confirmation_text_first: "",
      confirmation_text_second: "",
      shipping_states: [],
      billing_states: [],
      total_quantity: 0,
      phoneNumberElement: null,
      showShippingZipCode: false,
      shippingZipCodeMessage:
        "If you would like a quote for a different delivery address, please start over and enter the delivery address zip code",
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    //If the cart is empty or the terms_condition is not checked, go to select containers page
    if (this.VuexCartItem.length === 0 || !this.VuexTermsConditions)
      this.$router.push("/rentals/cart");
    else this.initializeDefaultCountryStates();

    //Add Event Listener to auto format phone number
    this.phoneNumberElement = document.getElementById("phone_number");
    this.phoneNumberElement.addEventListener("keydown", enforceFormat);
    this.phoneNumberElement.addEventListener("keyup", formatToPhone);
  },
  beforeDestroy() {
    //Remove Event Listener which was added on phone number
    this.phoneNumberElement.removeEventListener("keydown", enforceFormat);
    this.phoneNumberElement.removeEventListener("keyup", formatToPhone);
  },
  computed: {
    ...mapGetters({
      COUNTRY_CODE: types.COUNTRY_CODE,
      VuexCartItem: types.CARTLINEITEM,
      VuexTermsConditions: types.TERMSNCONDITIONS,
      VuexZipcode: types.ZIPCODE,
    }),
  },
  methods: {
    initializeDefaultCountryStates() {
      //Default the country based on domain name before DOM is loaded.
      if (this.COUNTRY_CODE === "US") {
        this.shipping_country = "United States";
        this.billing_country = "United States";
      } else if (this.COUNTRY_CODE === "CA") {
        this.shipping_country = "Canada";
        this.billing_country = "Canada";
      }
    },
    navigateCartPage() {
      this.$router.push("/rentals/cart");
    },
    shopifyAttributes() {
      return [
        {
          key: "market_code",
          value: this.VuexCartItem[0].market_code,
        },
      ];
    },
    createLineItemsShopify() {
      let lines = [];
      const cart = this.VuexCartItem;
      for (var index in cart) {
        let item = {
          quantity:
            parseInt(cart[index]["quantity"]) > 0
              ? parseInt(cart[index]["quantity"])
              : 1,
          merchandiseId: cart[index]["variantId"],
          sellingPlanId: cart[index]["sellingPlanId"],
          attributes: [
            {
              key: "Delivery",
              value: "RENTAL",
            },
          ],
        };

        lines.push(item);
      }
      return lines;
    },
    async shopifyCheckout() {
      let url, tokenID;
      if (this.COUNTRY_CODE === "US") {
        url = shopify_store.USAShopifyStorefrontUrl;
        tokenID = shopify_store.USAStorefrontAccessToken;
      } else if (this.COUNTRY_CODE === "CA") {
        url = shopify_store.CanadaShopifyStorefrontUrl;
        tokenID = shopify_store.CanadaStorefrontAccessToken;
      }

      let headers_list = {
        "X-Shopify-Storefront-Access-Token": tokenID,
        "content-type": "application/json",
      };

      const query = `
                    mutation cartCreateMutation($cartInput: CartInput) {
                    cartCreate(input: $cartInput) {
                        cart {
                        id
                        checkoutUrl
                        }
                    }
                    }
                    `;
      const variables = {
        cartInput: {
          lines: this.createLineItemsShopify(),
          attributes: this.shopifyAttributes(),
        },
      };

      try {
        let response = await axios({
          url: url,
          method: "post",
          data: {
            query: query,
            variables: variables,
          },
          headers: headers_list,
        });
        return response.data.data.cartCreate.cart.checkoutUrl;
      } catch (error) {
        console.log(error);
        return "";
      }
    },
    async sendDraftOrder() {
      this.makeDefault();
      if (this.same_addresses) this.updateBillingAddress();
      //Get line item variantID and quantity from the cart.
      const cart = this.VuexCartItem;
      //check for the required fields. If any required field is missing then return.
      if (!this.validateUserInputs()) return;
      //Loader starts
      this.userdata_sending = true;
      let shopifyCheckoutLink = "";

      shopifyCheckoutLink = await this.shopifyCheckout();
      if (!shopifyCheckoutLink) {
        this.email_send_acknowledge = true;
        this.confirmation_text_first =
          "Failed to process your request. Please ";
        this.confirmation_text_second = " for further assistance.";
        this.userdata_sending = false;
        return;
      }

      var lineItem = [],
        shippingPrice = 0;

      for (var index in cart) {
        var QUANTITY = cart[index]["quantity"];
        lineItem.push({
          variantId: cart[index]["id"],
          Quantity: QUANTITY,
          container_price: cart[index]["container_price"],
          container_description: cart[index]["container_size"],
        });

        this.total_quantity += QUANTITY;
        shippingPrice += cart[index]["hauling_price"] * QUANTITY;
      }
      const payload = this.getPayload(
        lineItem,
        shippingPrice,
        shopifyCheckoutLink
      );
      this.sendDataAWS(payload);
    },
    getPayload(lineItem, shippingPrice, shopifyCheckoutLink) {
      return {
        eventType: "rental_quote",
        customer_name: `${this.first_name} ${this.last_name}`,
        customer_email: this.email,
        email_cc: "",
        shipping_address: this.shipping_address,
        shipping_city: this.shipping_city,
        shipping_state: this.shipping_state,
        shipping_zip: this.VuexZipcode,
        billing_address: this.billing_address,
        billing_city: this.billing_city,
        billing_state: this.billing_state,
        billing_zip: this.billing_zipcode,
        delivery_charge: shippingPrice,
        total_tax: 0,
        checkout_link: shopifyCheckoutLink,
        country_code: this.COUNTRY_CODE,
        line_items: lineItem,
      };
    },
    updateBillingAddress() {
      //Update billing address to shipping address.
      this.billing_company = this.shipping_company;
      this.billing_address = this.shipping_address;
      this.billing_apartment = this.shipping_apartment;
      this.billing_city = this.shipping_city;
      this.billing_state = this.shipping_state;
      this.billing_zipcode = this.VuexZipcode;
      this.billing_country = this.shipping_country;
    },
    validateUserInputs() {
      /*Check if any value is empty or not. Contact information and billing info
      is required for either type of orders. Check for shipping address values
      if the order is delivery type. If all values entered return true.
      Else check which value is not entered by the user.*/
      let validation =
        this.first_name &&
        this.last_name &&
        this.phone_number &&
        this.email &&
        this.billing_address &&
        this.billing_city &&
        this.billing_state &&
        this.billing_country &&
        this.billing_zipcode &&
        this.shipping_address &&
        this.shipping_city &&
        this.shipping_state &&
        this.shipping_country;

      if (validation) return true;

      this.information_missing = true;
      if (this.first_name === "") this.first_name_empty = true;
      if (this.last_name === "") this.last_name_empty = true;
      if (this.phone_number === "") this.phone_number_empty = true;
      if (this.email === "") this.email_empty = true;
      if (this.billing_address === "") this.billing_address_empty = true;
      if (this.billing_city === "") this.billing_city_empty = true;
      if (this.billing_country === "") this.billing_country_empty = true;
      if (this.billing_state === "") this.billing_state_empty = true;
      if (this.billing_zipcode === "") this.billing_zipcode_empty = true;
      if (this.shipping_address === "") this.shipping_address_empty = true;
      if (this.shipping_city === "") this.shipping_city_empty = true;
      if (this.shipping_country === "") this.shipping_country_empty = true;
      if (this.shipping_state === "") this.shipping_state_empty = true;

      return false;
    },
    makeDefault() {
      this.information_missing = false;
      this.first_name_empty = false;
      this.last_name_empty = false;
      this.phone_number_empty = false;
      this.email_empty = false;
      this.billing_address_empty = false;
      this.billing_city_empty = false;
      this.billing_country_empty = false;
      this.billing_state_empty = false;
      this.billing_zipcode_empty = false;
      this.shipping_address_empty = false;
      this.shipping_city_empty = false;
      this.shipping_country_empty = false;
      this.shipping_state_empty = false;
    },
    sendDataAWS(payload) {
      const url =
        "https://8bikxb8159.execute-api.us-west-2.amazonaws.com/prod/rental-quotes";
      var headers_list = {
        "X-API-Key": "Nx7MdS0it08IjlOQ8Y21mah4WblpKjDn8jyfyus8",
        "content-type": "application/json",
      };
      axios
        .post(url, payload, { headers: headers_list })
        .then((response) => {
          this.displayMessage(response);
        })
        .catch((err) => {
          console.log(err);
          this.userdata_sending = false;
          this.email_send_acknowledge = true;
          this.confirmation_text_first =
            "Oops, something weird happened. Please ";
          this.confirmation_text_second = " for further assistance.";
        });
    },
    displayMessage(response) {
      const response_data = response.data;
      this.userdata_sending = false;
      const result = response_data.Result;
      if (result != "Success") {
        this.email_send_acknowledge = true;
        this.confirmation_text_first =
          "Failed to process your request. Please ";
        this.confirmation_text_second = " for further assistance.";
      } else {
        this.userdata_sent = true;
        setTimeout(() => {
          this.userdata_sent = false;
          this.email_send_acknowledge = true;
          this.confirmation_text_first =
            response_data.Message +
            " (please check your spam folder if you don't see it right away). You can always ";
          this.confirmation_text_second = " with any questions.";
        }, 2000);
      }
    },
  },
  watch: {
    //watcher on shipping and billing country. Based on the country code, display states.
    shipping_country: function (newValue, oldValue) {
      this.shipping_state = newValue != oldValue ? "" : this.shipping_state;
      if (newValue === "United States")
        this.shipping_states = states_list.US_States;
      else if (newValue === "Canada")
        this.shipping_states = states_list.Canada_States;
    },
    billing_country: function (newValue, oldValue) {
      this.billing_state = newValue != oldValue ? "" : this.billing_state;
      if (newValue === "United States")
        this.billing_states = states_list.US_States;
      else if (newValue === "Canada")
        this.billing_states = states_list.Canada_States;
    },
  },
};
</script>

<style scoped>
.btns {
  height: 50px;
  color: #00587d;
  text-decoration: none;
  text-transform: unset !important;
  border-radius: 20px;
  font-weight: 900;
  box-shadow: 1px 1px 1px 1px #ffffff;
  background-image: linear-gradient(to bottom, #6dbe45 0%, #3b701e 100%);
}

.custom-width {
  width: 80%;
}

label {
  color: #ffffff;
  padding-left: 10px;
}
.user_input_form {
  text-align: left;
}

.buttons button[class*="btn"] {
  margin-left: 10px;
  margin-right: 10px;
  margin-top: 10px;
  margin-bottom: 10px;
}

.form {
  border-radius: 25px;
  border: 2px solid green;
  padding: 10px;
  background-color: rgb(255, 255, 255);
  text-align: center;
  font-size: 15px;
  color: black;
  font-weight: 100;
}

.dropdown {
  border-radius: 25px;
  border: 2px solid green;
  background-color: rgb(255, 255, 255);
  text-align: center;
  color: black;
  font-weight: 100;
}
.sendAnimation {
  opacity: 1;
  animation-name: fadeInOpacity;
  animation-iteration-count: 1;
  animation-timing-function: ease-in;
  animation-duration: 0.5s;
}

@keyframes fadeInOpacity {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@media only screen and (max-width: 800px) {
  .custom-width,
  .form {
    width: 100%;
  }
}
</style>
